import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiMenu, mdiClose, mdiPhone, mdiWhatsapp, mdiBullhornOutline } from "@mdi/js";
import Logo from "./Logo";
import { useSite, useTheme } from "../theme/ThemeProvider";
import { services } from "../content/services";

const NAV = [
  { to: "/", label: "Ana Sayfa", exact: true },
  { to: "/hizmetler", label: "Hizmetler" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/blog", label: "Blog" },
  { to: "/iletisim", label: "İletişim" },
];

function useAnnouncement(site) {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("mu:ann") === "1");
  const a = site.announcement;
  if (!a?.enabled || dismissed || !a.text) return [false, () => {}];
  if (a.openingDate) {
    const end = new Date(a.openingDate + "T00:00:00");
    end.setDate(end.getDate() + 30);
    if (Date.now() > end.getTime()) return [false, () => {}];
  }
  return [
    true,
    () => {
      sessionStorage.setItem("mu:ann", "1");
      setDismissed(true);
    },
  ];
}

const Header = () => {
  const site = useSite();
  const { theme } = useTheme();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const [showAnn, dismissAnn] = useAnnouncement(site);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const dark = theme.headerStyle === "dark";

  return (
    <>
      {showAnn && (
        <div className="announcement" role="status">
          <div className="container">
            <Icon path={mdiBullhornOutline} size={0.8} />
            <span>
              {site.announcement.link ? <Link to={site.announcement.link}>{site.announcement.text}</Link> : site.announcement.text}
            </span>
            <button className="announcement__close" onClick={dismissAnn} aria-label="Duyuruyu kapat">
              <Icon path={mdiClose} size={0.75} />
            </button>
          </div>
        </div>
      )}
      <header className={`header${scrolled ? " is-scrolled" : ""}`}>
        <div className="container">
          <Logo light={dark} />
          <nav className="nav" aria-label="Ana menü">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} exact={n.exact} activeClassName="active">
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="header__actions">
            <a className="btn btn--ghost" href={`tel:${site.phoneHref}`}>
              <Icon path={mdiPhone} size={0.8} /> {site.phone}
            </a>
            <Link className="btn btn--primary" to="/iletisim">
              Randevu / Teklif
            </Link>
          </div>
          <button className="burger" onClick={() => setOpen(true)} aria-label="Menüyü aç" aria-expanded={open}>
            <Icon path={mdiMenu} size={1.1} />
          </button>
        </div>
      </header>

      {open && (
        <div className="drawer" role="dialog" aria-modal="true" aria-label="Menü">
          <div className="drawer__backdrop" onClick={() => setOpen(false)} />
          <div className="drawer__panel">
            <div className="drawer__head">
              <Logo />
              <button className="drawer__close" onClick={() => setOpen(false)} aria-label="Menüyü kapat">
                <Icon path={mdiClose} size={0.9} />
              </button>
            </div>
            {NAV.map((n) => (
              <React.Fragment key={n.to}>
                <NavLink to={n.to} exact={n.exact} className="drawer__link" activeClassName="active">
                  {n.label}
                </NavLink>
                {n.to === "/hizmetler" && (
                  <div className="drawer__sub">
                    {services.map((s) => (
                      <Link key={s.slug} to={`/hizmetler/${s.slug}`}>
                        {s.title}
                      </Link>
                    ))}
                  </div>
                )}
              </React.Fragment>
            ))}
            <div className="drawer__foot">
              <a className="btn btn--primary btn--block" href={`tel:${site.phoneHref}`}>
                <Icon path={mdiPhone} size={0.8} /> {site.phone}
              </a>
              <a
                className="btn btn--whatsapp btn--block"
                href={`https://wa.me/${site.whatsapp}`}
                target="_blank"
                rel="noreferrer"
              >
                <Icon path={mdiWhatsapp} size={0.8} /> WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
